// extracted by mini-css-extract-plugin
module.exports = {"VirtualList":"VirtualDroppable_VirtualList__AbetT"};